<template>
  <div v-if="showWechatForm" class="account-wechat-item tow-line-form">
    <a-form label-align="left" :colon="false">
      <a-form-item label="微信">
        <div class="single-edit-trigger is-text">
          <div>{{ weChatAccountLabel }}</div>
        </div>
      </a-form-item>
      <div class="mb-4 form-item-bottom">
        <a-button v-if="weChatStatus" type="link" @click="unBinding">
          {{ t('pages.settings.organization.self-settings.unbind') }}
        </a-button>
        <a-button v-else type="link" @click="binding">
          {{ t('pages.settings.organization.self-settings.bind') }}
        </a-button>
      </div>
    </a-form>
  </div>
  <Modal
    v-model:visible="visible"
    :title="setModalTitle"
    :okText="okText"
    @ok="handleOk"
    @open="handleOpen"
    @close="handleClose"
  >
    <template
      v-if="setModalTitle === t('pages.settings.organization.self-settings.updatePassword')"
    >
      <a-form
        labelAlign="left"
        :labelCol="{ span: 5 }"
        :rules="settingsRules"
        autoComplete="off"
        :model="updateMsg"
        ref="selfMsgRef"
      >
        <a-row :gutter="0">
          <a-col :span="24">
            <a-form-item
              name="account"
              :label="t('pages.settings.organization.self-settings.set.account')"
            >
              <a-input v-model:value="updateMsg.account" disabled /> </a-form-item
          ></a-col>
          <!-- <a-col :span="24">
            <a-form-item
              name="oldPassword"
              :label="t('pages.settings.organization.self-settings.old')"
              :wrapper-col="{ span: 20 }"
              :label-col="{ span: 4 }"
            >
              <a-input-password v-model:value="updateMsg.oldPassword" /> </a-form-item
          ></a-col> -->
          <a-col :span="24">
            <a-form-item
              name="newPassword"
              :label="t('pages.settings.organization.self-settings.new')"
            >
              <a-input-password v-model:value="updateMsg.newPassword" /> </a-form-item
          ></a-col>
          <a-col :span="24"
            ><a-form-item
              name="confirmNewPassword"
              :label="t('pages.settings.organization.self-settings.sureNew')"
            >
              <a-input-password v-model:value="updateMsg.confirmNewPassword" /> </a-form-item
          ></a-col>
        </a-row> </a-form
    ></template>
    <template v-if="setModalTitle === '设置账号密码'">
      <a-form
        labelAlign="left"
        :labelCol="{ span: 5 }"
        :rules="settingsRules"
        autoComplete="off"
        :model="updateMsg"
        ref="selfMsgRef"
      >
        <a-row :gutter="0">
          <a-col :span="24">
            <a-form-item
              name="account"
              :label="t('pages.settings.organization.self-settings.set.account')"
            >
              <a-input v-model:value="updateMsg.account" /> </a-form-item
          ></a-col>
          <a-col :span="24">
            <a-form-item
              name="password"
              :label="t('pages.settings.organization.self-settings.input.password')"
            >
              <a-input-password v-model:value="updateMsg.password" /> </a-form-item
          ></a-col>
          <a-col :span="24"
            ><a-form-item
              name="confirmPassword"
              :label="t('pages.settings.organization.self-settings.confirm.password')"
            >
              <a-input-password v-model:value="updateMsg.confirmPassword" /> </a-form-item
          ></a-col>
        </a-row> </a-form
    ></template>
    <template v-if="setModalTitle === t('pages.settings.organization.self-settings.bindPhone')">
      <a-form
        :rules="settingsRules"
        autoComplete="off"
        :model="updateMsg"
        labelAlign="left"
        :labelCol="{ span: 5 }"
        ref="selfMsgRef"
      >
        <a-form-item name="phone" :label="t('pages.settings.organization.self-settings.newPhone')">
          <a-input v-model:value="updateMsg.phone" />
        </a-form-item>

        <a-form-item name="code" :label="t('field.verificationCode')">
          <VerificationCodeInput
            v-model="updateMsg.code"
            size="small"
            :rest-seconds="setTime"
            @send="getCode"
          />
        </a-form-item>
      </a-form>
    </template>

    <template
      v-if="
        setModalTitle === t('pages.settings.organization.self-settings.updateEmail') ||
        setModalTitle === t('pages.settings.organization.self-settings.bindEmail')
      "
    >
      <a-form
        :rules="settingsRules"
        autoComplete="off"
        :model="updateMsg"
        labelAlign="left"
        :labelCol="{ span: 5 }"
        ref="selfMsgRef"
      >
        <a-form-item :label="t('pages.settings.organization.self-settings.emailNum')" name="email">
          <a-input v-model:value="updateMsg.email" />
        </a-form-item>
        <a-form-item name="code" :label="t('field.verificationCode')">
          <VerificationCodeInput
            v-model="updateMsg.code"
            size="small"
            :rest-seconds="setTime"
            @send="getCode"
          />
        </a-form-item>
      </a-form>
    </template>
  </Modal>
  <Modal
    v-model:visible="weChatVisible"
    :title="t('pages.settings.organization.self-settings.bindWeChat')"
    :footer="null"
    @close="handleWeChatClose"
  >
    <div class="wechat-bind-modal-body">
      <div id="bind-code" class="wechat-bind-code-wrap"></div>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { ref, watch, reactive, onMounted, computed, nextTick } from 'vue'
import { CollapsePanel, Collapse, Modal, VALIDATOR, Avatar } from '@elecmap/elecmap-ui'
import { CameraOutlined, PlusOutlined, LoadingOutlined } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
import type { IModalBtnItem } from '@elecmap/elecmap-ui/lib/modal/types'
import { commonHeader } from '@elecmap/api/src/client'
import { previewFile } from '@elecmap/api/src/cad/file'
import i18n from '../../i18n'
import useUserStore from '../../store/user'
import { storeToRefs } from 'pinia'
import { useRouter } from 'vue-router'
import { logoutAndGoToLoginAfterSetup } from '@/utils/login-navigation'
import VerificationCodeInput from '@elecmap/shared/src/components/VerificationCodeInput.vue'
import {
  querySelfInfo,
  bindEmail,
  updatePhoneInfo,
  updatePassword,
  updateNameInfo,
  updateGenderInfo,
  updateAvatar,
  unbindWeChat,
  queryBindConfig,
  checkBindingWechatVerification,
  updateEmployeeName,
  updateCart,
  queryUserEmployeeInfo,
  queryLoginInfo,
  updateUserName,
  verifyUserNameExist,
  verificationCode,
} from '@elecmap/api/src/ram'
import type { ResponseData, WeChatResponse } from '@elecmap/api/src/ram.d'
import { Icon } from '@elecmap/icon'

interface FileItem {
  uid: string
  name?: string
  status?: string
  response?: any
  url?: string
  type?: string
  size: number
  originFileObj: any
}
interface FileInfo {
  file: FileItem
  fileList: FileItem[]
}

const props = defineProps({
  type: String,
  showWechatForm: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['wechat-change', 'wechat-bind-request', 'refresh'])

const visible = defineModel<boolean>('visible', { default: false })

const router = useRouter()
const fileList = ref([])
const loading = ref<boolean>(false)
const previewVisible = ref()
const imageUrl = ref<string>('')
const addCardVisible = ref(false)
const accountButtonState = ref<boolean>(true)
const updateMsg = reactive({
  email: '',
  phone: '',
  code: '',
  oldPassword: '',
  newPassword: '',
  confirmNewPassword: '',
  account: '',
  password: '',
  confirmPassword: '',
  card: '',
})

const okText = ref<string>('确定')
const { userInfo, isLogin } = storeToRefs(useUserStore())
const { setUser } = useUserStore()

const handleChange = (info: FileInfo) => {
  // if (info.file.status === 'uploading') {
  //   loading.value = true
  //   return
  // }
  if (info.file.status === 'done' && info?.file?.response?.code === 200) {
    const id = info.file.response.data[0].uuid
    if (id) {
      imageUrl.value = id
      return
    }
  }
  loading.value = false
  // message.error('上传失败，请稍后重试')
}

const src = ref('https://www.skycoresaas.com')
const { t } = i18n.global

async function validateAccountUnique(_: any, value: string) {
  if (setModalTitle.value === t('pages.settings.organization.self-settings.updatePassword')) {
    return Promise.resolve()
  }
  if (!value) return Promise.resolve()
  if (/\s/.test(value)) {
    return Promise.reject(new Error('账号不能包含空格'))
  }
  try {
    const existed = await verifyUserNameExist({ userName: value })
    if (existed) {
      return Promise.reject(new Error('账号已存在'))
    }
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(new Error('账号校验失败，请稍后重试'))
  }
}

const settingsRules = {
  email: [
    { required: true, message: t('hint.input', { field: t('field.email') }), trigger: 'blur' },
    {
      pattern: VALIDATOR.pattern.email,
      validator: VALIDATOR.validate.common,
      message: VALIDATOR.message.email,
    },
  ],
  phone: [
    {
      required: true,
      message: t('hint.input', { field: t('pages.settings.organization.self-settings.phone') }),
      trigger: 'blur',
    },
    {
      pattern: VALIDATOR.pattern.mobile,
      validator: VALIDATOR.validate.common,
      message: VALIDATOR.message.mobile,
    },
  ],
  code: {
    required: true,
    message: t('hint.input', { field: t('field.verificationCode') }),
    trigger: 'blur',
  },
  oldPassword: {
    required: true,
    message: t('hint.input', { field: t('pages.settings.organization.self-settings.old') }),
    trigger: 'blur',
  },
  newPassword: [
    {
      required: true,
      message: t('hint.input', { field: t('pages.settings.organization.self-settings.new') }),
      trigger: 'blur',
    },
    {
      validator: (rule: any, value: string) => {
        if (updateMsg.oldPassword !== value) {
          return Promise.resolve()
        }
        return Promise.reject()
      },
      message: '新旧密码不能重复',
      trigger: 'blur',
    },
  ],
  confirmNewPassword: [
    {
      required: true,
      message: t('hint.input', { field: t('pages.settings.organization.self-settings.sureNew') }),
      trigger: 'blur',
    },
    {
      validator: (rule: any, value: string) => {
        if (updateMsg.newPassword === value) {
          return Promise.resolve()
        }
        return Promise.reject()
      },
      message: '新密码不一致',
      trigger: 'blur',
    },
  ],
  account: [
    {
      required: true,
      message: t('hint.input', {
        field: t('pages.settings.organization.self-settings.set.account'),
      }),
      trigger: 'blur',
    },
    {
      validator: validateAccountUnique,
      trigger: 'blur',
    },
  ],
  password: {
    required: true,
    message: t('hint.input', { field: t('pages.settings.organization.self-settings.password') }),
    trigger: 'blur',
  },
  confirmPassword: [
    {
      required: true,
      message: t('hint.input', {
        field: t('pages.settings.organization.self-settings.confirm.password'),
      }),
      trigger: 'blur',
    },
    {
      validator: (rule: any, value: string) => {
        if (updateMsg.password === value) {
          return Promise.resolve()
        }
        return Promise.reject()
      },
      message: t('pages.settings.organization.self-settings.noSame'),
      trigger: 'blur',
    },
  ],
}

const selfMsg = reactive({
  avatar: '',
  name: '',
  organizationRemarkName: '',
  enrollTime: '',
  userName: '',
  email: '',
  phone: '',
  newPhone: '',
  weChat: '',
  gender: '',
  genderName: '',
  code: '',
  card: '',
})
const activeKey = ref<string[]>(['0', '1', '2', '3', '4', '5', '6', '7'])
const headVisible = ref(false)
const modalButton = reactive<IModalBtnItem[]>([
  {
    key: 'addTwo',
    text: t('action.save'),
    type: 'primary',
    onClick: () => {
      if (imageUrl.value) {
        updateAvatar(imageUrl.value).then(() => {
          headVisible.value = false
          selfMsg.avatar = imageUrl.value
          imageUrl.value = ''
          fileList.value = []

          queryLoginInfo().then((res: ResponseData) => {
            userInfo.value.avatar = res.avatar
          })
        })
      }
    },
  },
  {
    key: 'addThree',
    text: t('action.cancel'),
    type: 'default',
    onClick: () => {
      headVisible.value = false
    },
  },
])
const selfsetStatus = ref('view')
const setButtonStatus = ref([
  {
    name: 'edit',
    title: t('action.edit'),
    type: 'primary',
  },
])
const weChatVisible = ref(false)

const setModalTitle = ref('')
const basicInfo = reactive({
  name: false,
  organizationRemarkName: false,
  gender: false,
  card: false,
})

const selfMsgCancel = reactive({
  name: '',
  organizationRemarkName: '',
  gender: '',
  cart: '',
})
const weChatStatus = ref(true)
const weChatAccountLabel = computed(() => {
  if (!weChatStatus.value) {
    return '-'
  }
  return selfMsg.weChat || '-'
})
let bindingCheckTimer: number | undefined
let bindQrRefreshTimer: number | undefined
let bindWeChatConfig: WeChatResponse | undefined

function clearWeChatBindTimers() {
  if (bindingCheckTimer) {
    window.clearInterval(bindingCheckTimer)
    bindingCheckTimer = undefined
  }
  if (bindQrRefreshTimer) {
    window.clearTimeout(bindQrRefreshTimer)
    bindQrRefreshTimer = undefined
  }
}

function handleWeChatClose() {
  clearWeChatBindTimers()
}

function checkBindingScan() {
  checkBindingWechatVerification({ hideToast: true })
    .then(data => {
      if (data) {
        clearWeChatBindTimers()
        weChatVisible.value = false
        queryBasicInfo()
        emit('wechat-change')
        message.success(t('message.operatedSuccessfully'))
      }
    })
    .catch((e: { data?: { message?: string } }) => {
      clearWeChatBindTimers()
      weChatVisible.value = false
      if (e?.data?.message) {
        message.error(e?.data?.message)
      }
    })
}

function startBindingCheck() {
  clearWeChatBindTimers()
  bindingCheckTimer = window.setInterval(() => {
    checkBindingScan()
  }, 1000)
}

const drawBindQRCode = () => {
  if (bindQrRefreshTimer) {
    window.clearTimeout(bindQrRefreshTimer)
  }

  const drawInner = () => {
    if (!bindWeChatConfig) {
      return
    }
    new window.WxLogin({
      ...bindWeChatConfig,
      id: 'bind-code',
      self_redirect: true,
    })
    bindQrRefreshTimer = window.setTimeout(drawBindQRCode, 3 * 60 * 1000)
  }

  queryBindConfig().then(res => {
    bindWeChatConfig = res
    drawInner()
    startBindingCheck()
  })
}

const queryBasicInfo = () => {
  querySelfInfo().then((data: any) => {
    selfMsg.name = data.name
    selfMsg.card = data.card
    selfMsg.enrollTime = data.registerTime
    selfMsg.userName = data.userName
    selfMsg.email = data.email
    selfMsg.phone = data.phone
    selfMsg.gender = data.gender
    selfMsg.genderName = data.genderName
    selfMsg.avatar = data.avatar
    selfMsg.weChat = data.weChat || data.wechatNickname || ''
    selfMsgCancel.name = data.name
    selfMsgCancel.gender = data.genderName
    weChatStatus.value = data.bindWechat
    const bindWechatErrorMessages = data.bindWechatErrorMessage
    if (bindWechatErrorMessages) {
      message.error(bindWechatErrorMessages)
    }
  })
}
onMounted(() => {
  if (props.showWechatForm) {
    queryBasicInfo()
    queryUserEmployeeInfo().then((data: any) => {
      selfMsg.organizationRemarkName = data.employeeName
      selfMsgCancel.organizationRemarkName = data.employeeName
    })
  }
})
let timer: any
const setTime = ref(0)

const getCode = () => {
  const isEmailAction =
    setModalTitle.value === t('pages.settings.organization.self-settings.updateEmail') ||
    setModalTitle.value === t('pages.settings.organization.self-settings.bindEmail')
  if (isEmailAction) {
    if (!updateMsg.email) {
      message.error(t('hint.input', { field: t('field.email') }))
      return
    }
    if (!VALIDATOR.pattern.email.test(updateMsg.email)) {
      message.error(VALIDATOR.message.email)
      return
    }
  }
  setTime.value = 60
  timer = setInterval(() => {
    setTime.value -= 1
    if (setTime.value === 0) {
      clearInterval(timer)
    }
  }, 1000)

  verificationCode(
    isEmailAction ? { email: updateMsg.email } : { phone: updateMsg.phone || selfMsg.phone },
  ).then(() => {
    //
  })
}
const beforeUpload = (file: any) => {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
  if (!isJpgOrPng) {
    message.error('请上传正确格式的图片')
  }
  const isLt2M = file.size / 1024 / 1024 < 2
  if (!isLt2M) {
    message.error('请上传小于2MB的图片')
  }
  return isJpgOrPng && isLt2M
}

const selfMsgRef = ref()
const updateMsgRef = ref()
const resetUpdateMsg = () => {
  updateMsg.email = ''
  updateMsg.phone = ''
  updateMsg.code = ''
  updateMsg.oldPassword = ''
  updateMsg.newPassword = ''
  updateMsg.confirmNewPassword = ''
  updateMsg.account = ''
  updateMsg.password = ''
  updateMsg.confirmPassword = ''
  updateMsg.card = ''
}

const handleClose = () => {
  clearInterval(timer)
  setTime.value = 0
  setModalTitle.value = ''
  resetUpdateMsg()
  selfMsgRef.value?.clearValidate?.()
}

const handleOk = () => {
  selfMsgRef.value.validate().then(() => {
    if (
      setModalTitle.value === t('pages.settings.organization.self-settings.updateEmail') ||
      setModalTitle.value === t('pages.settings.organization.self-settings.bindEmail')
    ) {
      bindEmail(
        {
          email: updateMsg.email,
          verificationCode: updateMsg.code,
        },
        { hideToast: true },
      )
        .then(() => {
          selfMsg.email = updateMsg.email
          updateMsg.code = ''
          setTime.value = 0
          clearInterval(timer)
          visible.value = false
          emit('refresh')
        })
        .catch(error => {
          message.warn(error?.data?.message)
        })
    }
    if (setModalTitle.value === t('pages.settings.organization.self-settings.bindPhone')) {
      updatePhoneInfo(
        { phone: updateMsg.phone, verificationCode: updateMsg.code },
        { hideToast: true },
      )
        .then(() => {
          selfMsg.phone = updateMsg.phone
          visible.value = false
          emit('refresh')
        })
        .catch(e => {
          message.error(e?.data?.message)
        })
    }
    // updateMsgRef.value.validate().then()
    if (setModalTitle.value === t('pages.settings.organization.self-settings.updatePassword')) {
      updatePassword({
        oldPassword: updateMsg.oldPassword,
        newPassword: updateMsg.newPassword,
        confirmPassword: updateMsg.oldPassword,
      }).then(async () => {
        visible.value = false
        message.success(t('message.updateSuccessfully'))
        await logoutAndGoToLoginAfterSetup(to => router.replace(to))
      })
    }

    if (setModalTitle.value === '设置账号密码') {
      updateUserName({
        userName: updateMsg.account,
      }).then(() => {
        updatePassword({
          oldPassword: '',
          newPassword: updateMsg.password,
          confirmPassword: updateMsg.confirmPassword,
        }).then(async () => {
          selfMsg.userName = updateMsg.account
          visible.value = false
          accountButtonState.value = false
          message.success(t('message.operatedSuccessfully'))
          await logoutAndGoToLoginAfterSetup(to => router.replace(to))
        })
      })
    }
  })
}
const handleAddCardOk = () => {
  updateCart(imageUrl.value).then(() => {
    imageUrl.value = ''
    fileList.value = []
    addCardVisible.value = false

    queryBasicInfo()
  })
}
const updateHead = () => {
  // console.log(1111)

  headVisible.value = true
}
const updateName = () => {
  userInfo.value.name = selfMsg.name
  updateNameInfo({ name: selfMsg.name }).then(() => {
    basicInfo.name = false
    selfMsgCancel.name = selfMsg.name
  })
  // if (VALIDATOR.pattern.chineseOrNumberOrEnglish.test(selfMsg.name)) {
  //   userInfo.value.name = selfMsg.name
  //   updateNameInfo({ name: selfMsg.name }).then(() => {
  //     basicInfo.name = false
  //     selfMsgCancel.name = selfMsg.name
  //   })
  // } else {
  //   message.warn(VALIDATOR.message.chineseOrNumberOrEnglish)
  // }
}

const cancelUpdateName = () => {
  selfMsg.name = selfMsgCancel.name
  basicInfo.name = false
}

const updateOrganizationRemarkName = () => {
  if (VALIDATOR.pattern.chineseOrNumberOrEnglish.test(selfMsg.organizationRemarkName)) {
    userInfo.value.employeeName = selfMsg.organizationRemarkName
    updateEmployeeName({ employeeName: selfMsg.organizationRemarkName }).then(() => {
      basicInfo.organizationRemarkName = false
      selfMsgCancel.organizationRemarkName = selfMsg.organizationRemarkName
    })
  } else {
    message.warn(VALIDATOR.message.chineseOrNumberOrEnglish)
  }
}

const cancelUpdateOrganizationRemarkName = () => {
  selfMsg.organizationRemarkName = selfMsgCancel.organizationRemarkName
  basicInfo.organizationRemarkName = false
}

const cancelUpdateGender = () => {
  selfMsg.genderName = selfMsgCancel.gender
  basicInfo.gender = false
}
const updateGender = () => {
  updateGenderInfo({ gender: selfMsg.gender }).then(() => {
    basicInfo.gender = false
    // selfMsg.gender =
    selfMsgCancel.gender = selfMsg.gender === 'man' ? '男' : '女'
  })
}

function handleOpen() {
  if (props.type === 'pwd') {
    updatePassWord()
  }
  if (props.type === 'email') {
    updateEmail()
  }
  if (props.type === 'phone') {
    updatePhone()
  }
  if (props.type === 'account') {
    updateAccount()
  }
}

const updatePhone = () => {
  visible.value = true
  setModalTitle.value = t('pages.settings.organization.self-settings.bindPhone')
}
const updatePassWord = () => {
  visible.value = true
  setModalTitle.value = t('pages.settings.organization.self-settings.updatePassword')
  updateMsg.account = selfMsg.userName || ''
}
const updateEmail = () => {
  visible.value = true
  if (selfMsg.email) {
    setModalTitle.value = t('pages.settings.organization.self-settings.updateEmail')
  } else {
    setModalTitle.value = t('pages.settings.organization.self-settings.bindEmail')
  }
}
const updateAccount = () => {
  visible.value = true
  setModalTitle.value = '设置账号密码'
}
const unBinding = () => {
  Modal.confirm({
    content: t('pages.settings.organization.self-settings.unbindMsg', { field: selfMsg.weChat }),
    onOk: () => {
      unbindWeChat().then(() => {
        weChatStatus.value = false
        selfMsg.weChat = ''
        message.success(t('message.operatedSuccessfully'))
        emit('wechat-change')
      })
    },
  })
}
function openWeChatBinding() {
  weChatVisible.value = true
  nextTick(() => {
    drawBindQRCode()
  })
}

const binding = () => {
  emit('wechat-bind-request')
}

defineExpose({ openWeChatBinding })

const goWorkbench = () => {
  router.push({ path: '/workbench' })
}

watch(selfsetStatus, newStatus => {
  if (newStatus === 'view') {
    setButtonStatus.value = [
      {
        name: 'edit',
        title: t('action.edit'),
        type: 'primary',
      },
    ]
  }
  if (newStatus === 'edit') {
    setButtonStatus.value = []
  }
})

watch(
  () => headVisible.value,
  newData => {
    if (newData) {
      imageUrl.value = ''
      loading.value = false
    }
  },
)

watch(setModalTitle, () => {
  okText.value = '确定'
})
</script>

<style scoped lang="less">
@import url('~@elecmap/elecmap-ui/lib/styles/basic.less');

.wechat-bind-modal-body {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 280px;
  padding: 16px 0;
}

.wechat-bind-code-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  text-align: center;
}

.account-wechat-item {
  :deep(.ant-form-item) {
    flex-direction: column;
    margin-bottom: 24px;

    .ant-form-item-label {
      width: 100%;
      max-width: 100%;
      flex: none;
      display: block;
      margin-bottom: 12px;

      > label {
        font-size: 14px;
        font-weight: 450;
      }
    }

    .ant-form-item-control {
      flex: none;
    }

    .single-edit-trigger {
      width: auto;
      min-width: 30px;
    }
  }

  .form-item-bottom {
    transform: translate(-6px, -24px);
  }
}

.return-workbench {
  display: flex;
  align-items: center;
  transform: translateX(-9px);
  margin-bottom: 16px;
  margin-top: 8px;
  cursor: pointer;

  .workbench-name {
    font-size: 13px;
    line-height: 24px;
  }
}

.editMsg,
.safeMsg,
.third {
  .updateBasic {
    margin-right: 30px;
  }

  .ant-row {
    margin-bottom: 30px;
  }

  .msg {
    display: inline-block;
    width: 240px;
    text-align: left;
    color: black;
  }

  p {
    // font-size: 14px;
    .head {
      width: 50px;
      height: 50px;
      border-radius: 5px;
    }

    span {
      display: inline-block;
      margin: 10px 50px 10px 0;
      width: 100px;
      // font-size: 16px;
      text-align: left;
      color: #999999;
    }
  }
}

.weChat {
  width: 50px;
  height: 50px;
  border-radius: 10px;
}

.delete {
  display: flex;
  align-items: center;
  margin-left: 225px;

  span {
    font-size: 14px;
    color: rgb(217 0 27);
  }
}

.editMsg,
.editSafe {
  .editImg {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    font-size: 20px;
    border-radius: 10px;
    color: white;
    // background-color: @primary-color;
  }
}

.weChatImg {
  display: inline-block;
  margin-right: 100px;
  width: 80px;
  text-align: right;
}

.code {
  margin: 5px 0 0 10px;
  font-size: 14px;
}

.binding {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  img {
    width: 50%;
  }
}

.third {
  .iconfont {
    color: #6bc839;
  }
}

.headUpload {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;

  .anticon-camera {
    position: absolute;
    display: none;
  }
}

.headUpload:hover {
  .editImg {
    opacity: 0.5;
  }

  .anticon-camera {
    display: block;
  }
}

.modalHead {
  width: 70%;

  img {
    width: 80%;
  }
}

.addCard {
  .coldCard {
    img {
      width: 60%;
    }
  }

  > div {
    width: 50%;
  }

  display: flex;
  justify-content: space-between;
}

:deep(.ant-modal) {
  background-color: red;

  .ant-modal-footer {
    padding: 0;
  }
}
</style>

<style>
.user-setting-collapse {
  .em-collapse-main-header {
    color: rgba(0, 0, 0, 0.85) !important;
  }
  .ant-collapse-arrow {
    display: none !important;
  }
  .ant-collapse-content-box {
    padding: 30px 8px 8px 16px !important;
  }
}
</style>
